module.exports = __webpack_public_path__ + "img/2024-ford-transit.b16301e1.png";